// @ts-ignore
import React, { useState, useLayoutEffect } from "react";
import { mutateUrls } from "../../../lib/useGenericSWR";
import { useSWRConfig } from "swr";
// @ts-ignore
import { EnsureUser } from "../../auth/EnsureUser";
import { useTranslation } from "react-i18next";
import { UcWidget } from "../../common/UcWidget";
// @ts-ignore
import { useResponsive } from 'lib/useResponsive';
import { Alert, Button,  } from "@mui/material";
import { ActionItem } from "../../common/Common.interfaces";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// @ts-ignore
import { routePaths } from "routes";
import { useDomainNavigate } from "../../../domain";
import { UcLoading } from "../../common/UcLoading";
// @ts-ignore
import { dayFormatter, ensureLuxonDateUtcToTimezone } from '../../../lib/Formatters';
import { useUserEventLogs } from "../Users/UserEventLogsAPIEndpoints";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
// @ts-ignore
import { DateTime } from 'luxon';
import { useMyTimezone } from 'components/customer/orgs/MyOrgAPIEndpoints';


export const AdminUserLoginsWidget = () => {
    const { t } = useTranslation();
    const timezone = useMyTimezone();
    const [reMutateUrls, setReMutateUrls] = useState(false);
    const swrConfig = useSWRConfig();
    const { isMobile } = useResponsive();
    const navigate = useDomainNavigate();
    let hasUserEventLogs = true;

    const today = new Date();
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(today.getDate() - 14);

    const eventLogFilter = React.useMemo(() => {
        const today = new Date();
        const twoWeeksAgo = new Date();
        twoWeeksAgo.setDate(today.getDate() - 14);

        return {
            eventType: "Login",
            startDate: twoWeeksAgo.toISOString(),
            endDate: today.toISOString()
        };
    }, []); 


    const swrUserEventLogs = useUserEventLogs(eventLogFilter);

    if (swrUserEventLogs?.result?.length < 1 && !swrUserEventLogs?.isLoading && !swrUserEventLogs?.isError) {
        hasUserEventLogs = false;
    }

    const loginCountsPerDay = React.useMemo(() => {
        const today = DateTime.local().setZone(timezone).startOf('day');
        const twoWeeksAgo = today.minus({ days: 13 });

        // Two weeks ago to today
        const days: string[] = [];
        for (let d = twoWeeksAgo; d <= today; d = d.plus({ days: 1 })) {
            days.push(d.toISODate());
        }

        const loginCounts: Record<string, number> = {};
        swrUserEventLogs?.result?.forEach((log: any) => {
            const day = ensureLuxonDateUtcToTimezone(log.eventTsUtc, timezone).toISODate();
            if (day) {
                loginCounts[day] = (loginCounts[day] || 0) + 1;
            }            
        });       

        return days.map(date => ({
            date,
            count: loginCounts[date] || 0
        }));
    }, [swrUserEventLogs?.result, timezone]);

    const handleClickGoToUserLogins = () => {
        navigate(routePaths.userLoginsPage.path);
    };

    const actionItems: ActionItem[] = [
        {
            component: (
                <Button
                    color={"info"}
                    onClick={handleClickGoToUserLogins}
                    size={"small"}
                    endIcon={<ChevronRightIcon />}
                >
                    {t("View User Logins")}
                </Button>
            ),
        },
    ];

    useLayoutEffect(() => {
        if (reMutateUrls) {
            mutateUrls(swrConfig);
            setReMutateUrls(false);
        }
    }, [reMutateUrls, swrConfig]);

    console.log("AdminUserLoginsWidget - Loaded");

    return (
        <UcWidget
            title={t("User Logins")}
            actionItems={actionItems}
            alignTitleLeft={false}
            contentPadding={isMobile && '0 0 1rem 0'}
        >
            <EnsureUser permissions={["UserEventLogs:Read"]}>
                <div data-cy-id="admin_user_logins_widget">
                    <UcLoading
                        hasFade={false}
                        hasError={swrUserEventLogs?.isError}
                        isLoading={swrUserEventLogs?.isLoading}
                        height={"20vh"}
                        errorMessage={t(
                            "An error occurred retrieving user event logs."
                        )}
                    >
                        {hasUserEventLogs ?
                            <ResponsiveContainer width="100%" height={300}>
                                <LineChart data={loginCountsPerDay} margin={{ top: 5, right: 40, left: -20, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="2 2" />
                                    <XAxis 
                                        dataKey="date" 
                                        tickFormatter={(value) => dayFormatter(value, "", true)}
                                    />
                                    <YAxis allowDecimals={false} axisLine={false} />
                                    <Tooltip 
                                        labelFormatter={(value) => dayFormatter(value, "", true)}
                                        formatter={(value, name) => [value, 'Login Count']}
                                    />
                                    <Line type="monotone" dataKey="count" stroke="#8884d8" strokeWidth={3} />
                                </LineChart>
                            </ResponsiveContainer>
                            :
                            <Alert severity="warning">{t("No user login stats were found.")}</Alert>
                        }
                    </UcLoading>
                </div>               
            </EnsureUser>
        </UcWidget>
    );
};
